import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { notifyAuthChange } from './services/api';
import { initMonitoring, MonitoringErrorBoundary } from './services/monitoring';
import './i18n/i18n';
import './styles.css';

initMonitoring();

if (typeof window !== 'undefined') {
  window.addEventListener('storage', (event) => {
    if (event.key === 'academic-review-auth-token' || event.key === 'academic-review-supabase-session') {
      notifyAuthChange();
    }
  });
}

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <MonitoringErrorBoundary fallback={<div className="route-shell"><div className="route-card route-card-danger"><p className="route-kicker">Application Error</p><h2 className="route-title">页面出现错误</h2><p className="route-copy">错误已记录，请刷新页面或返回工作台。</p></div></div>}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </MonitoringErrorBoundary>
  </React.StrictMode>,
);
